// src/components/generics/ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import axiosInstance from "../../utils/AxiosInstance";
import { clearAuth } from "../../utils/authStorage";
import { loginUser } from "../../redux/actions/userActions";

const buildUser = (data) => ({
  id: data?.id,
  name: data?.name,
  email: data?.email,
  type: data?.type,
  account: data?.account,
  credits: data?.account?.credit,
  buyDrawActiveMegaMillions: data?.buyDrawActiveMegaMillions,
  buyDrawActivePowerBall: data?.buyDrawActivePowerBall,
  impersonating: data?.impersonating === true,
});

const notify = (authenticated, user = null) => {
  window.dispatchEvent(
    new CustomEvent("auth:changed", {
      detail: { authenticated, source: "protected-route", user },
    })
  );
};

export default function ProtectedRoute({ element }) {
  const dispatch = useDispatch();
  const [authed, setAuthed] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await axiosInstance.get("/site/user/logged-user");
        const user = buildUser(res?.data);
        if (!user.id) throw new Error("No user");
        dispatch(loginUser(user));
        notify(true, user);
        if (mounted) setAuthed(true);
      } catch {
        clearAuth();
        notify(false);
        if (mounted) setAuthed(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [dispatch]);

  if (authed === null) {
    // Loading shim — matches the rest of the dark theme
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "var(--bg)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "var(--txt-2)",
        }}
      >
        <i
          className="ti ti-loader-2 spin"
          style={{ fontSize: 28, color: "var(--gold-lt)" }}
        />
      </div>
    );
  }

  return authed ? element : <Navigate to="/login" replace />;
}
